module.exports = __webpack_public_path__ + "static/img/icon_ai_jishu_jingzhun_shaicha.21ee9c2d.png";